import api from '@api/Api';

export default {

    getMember(id) {
        return api().get(`/members/${id}`);
    },

    updateMember(id, params) {
        return api().put(`/members/${id}`, params);
    },

    deleteMember(id) {
        return api().delete(`/members/${id}`);
    },

    getProjects(id, params) {
        return api().get(`/members/${id}/projects`, { params: params });
    },

    favoriteProject(id, projectId) {
        return api().put(`/members/${id}/projects/${projectId}/favorite`);
    },

    unfavoriteProject(id, projectId) {
        return api().put(`/members/${id}/projects/${projectId}/unfavorite`);
    },

}
